import React, {useState} from "react";

import "./AllWeather.css";

import TopNav from "../components/TopNav";
import AllWeatherPublic from "../components/AllWeatherPublic";
import AllWeatherMembersOnly from "../components/AllWeatherMembersOnly";


const AllWeatherOpsPage = (props) => {


    const [membersOnly, setMembersOnly] = useState(false);

    const handleMembersOnly = () => {
        setMembersOnly(true);
    };

    return(
        <React.Fragment>
            <TopNav page={props.page} darkMode={props.darkmode} />
            <div>{membersOnly}</div>
            {!membersOnly && <AllWeatherPublic cat23={props.cat23}  handleMembersOnly={handleMembersOnly} />}
            {membersOnly && <AllWeatherMembersOnly cat23={props.cat23} darkMode={props.darkmode} />}

        </React.Fragment>
    );
}

export default AllWeatherOpsPage;
